/**
 * GA4 Footer Events - Fires click events for footer links
 * Event names: clickAboutUsLink, clickPrivacyPolicyLink, etc.
 * Params: page_location, page_title, referrer, page_type, link_name, clickURL
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  function getPageParams() {
    const route = window.trovelle?.ga4?.route?.getRoute?.();
    const pt = route?.pageType || 'page';
    const pageType = pt.charAt(0).toUpperCase() + pt.slice(1);
    return {
      page_location: window.location.href,
      page_title: document.title || '',
      referrer: document.referrer || '',
      page_type: pageType,
    };
  }

  function toEventName(linkName) {
    if (!linkName || typeof linkName !== 'string') return 'clickFooterLink';
    const words = linkName.trim().split(/\s+/).filter(Boolean);
    const pascal = words.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join('');
    return 'click' + pascal + 'Link';
  }

  function getLinkName(link) {
    const ariaLabel = link.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel.trim();

    const href = (link.getAttribute('href') || '').toLowerCase();
    if (href.startsWith('tel:')) return 'Phone';
    if (href.startsWith('mailto:')) return 'Email';

    return (link.textContent || '').trim();
  }

  function handleFooterClick(e) {
    const link = e.target?.closest?.('a[href]');
    if (!link) return;

    const inFooter = link.closest('footer') || link.closest('[data-testid="footer-utilities"]');
    if (!inFooter) return;

    const linkName = getLinkName(link);
    const eventName = toEventName(linkName);

    gtag('event', eventName, {
      ...getPageParams(),
      link_name: linkName,
      clickURL: link.href || '',
    });
  }

  function init() {
    document.addEventListener('click', handleFooterClick, { capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
